import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getListFunc(params) {
  return request({
    url: URL.mdm.basicData.transportTypeUrl,
    method: 'get',
    params
  })
}

export function saveTransportTypeFunc(data) {
  return request({
    url: URL.mdm.basicData.transportTypeUrl,
    method: 'post',
    data
  })
}

export function deleteTransportTypeFunc(uuid) {
  return request({
    url: URL.mdm.basicData.transportTypeUrl + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
